import { InteractionTypeEnum } from 'enums';

import { MapBrowserEvent } from 'ol';
import DrawHole from 'ol-ext/interaction/DrawHole';
import Transform from 'ol-ext/interaction/Transform';
import UndoRedo from 'ol-ext/interaction/UndoRedo';
import { ObjectEvent } from 'ol/Object';
import { Draw, Modify, Select } from 'ol/interaction';

import { drawDeleteVectorSource, drawVectorLayer, drawVectorSource } from './Layers';
import {
  deleteVertexStyle,
  drawDeleteStyle,
  drawPolygonStyle,
  getDefaultStyleFunction,
  modifyCircleStyle
} from './Styles';

export type InteractionType = keyof typeof InteractionTypeEnum;

export const drawInteraction = new Draw({
  source: drawVectorSource,
  type: 'Polygon',
  style: getDefaultStyleFunction()
});
drawInteraction.set('type', InteractionTypeEnum.DRAW);
drawInteraction.setActive(false);

export const selectInteraction = new Select({
  layers: [drawVectorLayer],
  style: [...deleteVertexStyle, drawPolygonStyle]
});
selectInteraction.set('type', InteractionTypeEnum.SELECT);
selectInteraction.setActive(false);

selectInteraction.on('change:active', (objectEvent: ObjectEvent) => {
  if (objectEvent.target.get('active') === false) {
    drawDeleteVectorSource.clear();
    selectInteraction.getFeatures().clear();
  }
});

export const modifyInteraction = new Modify({
  source: drawVectorSource,
  pixelTolerance: 25,
  style: modifyCircleStyle
});
modifyInteraction.set('type', InteractionTypeEnum.MODIFY);
modifyInteraction.setActive(false);

export const modifyDeleteInteraction = new Modify({
  source: drawVectorSource,
  style: drawDeleteStyle,
  deleteCondition: (mapBrowserEvent: MapBrowserEvent<MouseEvent>) =>
    mapBrowserEvent.type === 'singleclick' || mapBrowserEvent.type === 'click',
  insertVertexCondition: () => false
});
modifyDeleteInteraction.set('type', InteractionTypeEnum.MODIFY_DELETE);
modifyDeleteInteraction.setActive(false);

export const transformInteraction = new Transform({
  stretch: false,
  translate: true,
  layers: [drawVectorLayer]
});
transformInteraction.set('type', InteractionTypeEnum.TRANSFORM);
transformInteraction.setActive(false);

export const drawHoleInteraction = new DrawHole({
  layers: [drawVectorLayer]
});
drawHoleInteraction.set('type', InteractionTypeEnum.DRAW_HOLE);
drawHoleInteraction.setActive(false);

export const undoInteraction = new UndoRedo({
  layers: [drawVectorLayer]
});
